import { render } from "./Toast.vue?vue&type=template&id=12d4c48c"
import script from "./Toast.vue?vue&type=script&lang=js"
export * from "./Toast.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__